import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import howItWorks1 from "@/assets/how-it-works-1-new.png";
import howItWorks2 from "@/assets/how-it-works-2-new.png";
import howItWorks3 from "@/assets/how-it-works-3-new.png";

export default function HowItWorks() {
  const steps = [
    {
      title: "Throw Your Materials In",
      description:
        "PDFs, YouTube links, recorded lectures, voice notes. Shattara handles it all so you never have to re-explain what you're studying.",
      image: howItWorks1,
    },
    {
      title: "Get It Explained Until It Actually Clicks",
      description:
        "Ask anything in your own words. Get step-by-step breakdowns, visual explanations, and targeted quizzes. Shattara keeps explaining until you get it.",
      image: howItWorks2,
    },
    {
      title: "Know You're Actually Ready for the Exam",
      description:
        "Shattara finds the gaps in your knowledge before your exam does, then gives you targeted practice to close them. No more exam-day surprises.",
      image: howItWorks3,
    },
  ];

  return (
    <section className="w-full bg-muted py-24 px-6 md:px-10" id="how-it-works">
      <div className="container mx-auto max-w-[75rem]">
        <div className="flex flex-col gap-14">
          {/* Header Section */}
          <div className="flex flex-col items-center gap-4">
            <h2 className="text-4xl leading-none text-foreground text-center font-medium md:text-6xl max-w-[50rem]">
              Go from Confused to Confident — in 3 Steps.
            </h2>

            <p className="text-center max-w-[50rem] text-muted-foreground">
              Upload what you have. Shattara does the rest — so you can spend your time actually learning, not preparing
              to learn.
            </p>
          </div>

          {/* Steps Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {steps.map((step, index) => (
              <Card key={index} className="overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-xl">
                <CardHeader>
                  <CardTitle className="text-2xl">{step.title}</CardTitle>
                  <CardDescription className="text-muted-foreground">{step.description}</CardDescription>
                </CardHeader>
                <CardContent className="p-0">
                  <div className="w-full h-56 overflow-hidden">
                    <img
                      src={step.image}
                      alt={step.title}
                      width={600}
                      height={224}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                    />
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
